import * as THREE from 'three';

declare module 'three' {
  interface PerspectiveCamera {
    zoomTo(node: THREE.Object3D, factor?: number): void;
  }
}

THREE.PerspectiveCamera.prototype.zoomTo = function (
  this: THREE.PerspectiveCamera,
  node: THREE.Object3D,
  factor?: number,
): void {
  if (!(node as any).geometry && !(node as any).boundingSphere && !(node as any).boundingBox) {
    return;
  }

  if ((node as any).geometry && (node as any).geometry.boundingSphere === null) {
    (node as any).geometry.computeBoundingSphere();
  }

  node.updateMatrixWorld();

  let bs: THREE.Sphere;

  if ((node as any).boundingSphere) {
    bs = (node as any).boundingSphere;
  } else if ((node as any).geometry && (node as any).geometry.boundingSphere) {
    bs = (node as any).geometry.boundingSphere;
  } else {
    bs = (node as any).boundingBox.getBoundingSphere(new THREE.Sphere());
  }

  const _factor = factor || 1;

  bs = bs.clone().applyMatrix4(node.matrixWorld);
  const radius = bs.radius;
  let fovr = (this.fov * Math.PI) / 180;

  if (this.aspect < 1) {
    fovr = fovr * this.aspect;
  }

  const distanceFactor = Math.abs(radius / Math.sin(fovr / 2)) * _factor;

  const offset = this.getWorldDirection(new THREE.Vector3()).multiplyScalar(-distanceFactor);
  this.position.copy(bs.center.clone().add(offset));
};
